import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.589 9H0V7h11.583l-4.33-4.33 1.414-1.415 6.04 6.04a1 1 0 0 1 0 1.415l-6.04 6.04-1.415-1.414L11.59 9z",
		fill: "currentColor"
	})
});
export default SvgArrowRightinline;
